import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";

import { ReactDualList } from "../../components/Component";
import MobileSelector from "./MobileSelector";

const UsStateSelectModal = ({
  modalForm,
  setModalForm,
  setSelectedZone,
  selectedZone,
  userData,
  handleSelectedState,
}) => {
  // const [loading, setLoading] = useState(false);
  const loading = false;
  const [selectedStates, setSelectedStates] = useState([]);
  const localHandleSelectedState = (selected) => {
    setSelectedStates(selected);
  };
  const [selectedZonesLastModified, setSelectedelectedZonesLastModified] =
    useState(["All Zones"]);
  const toggleForm = () => setModalForm(!modalForm);

  const options = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
  ];
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <Modal isOpen={modalForm} className="custom-modal-width " size="lg">
      <ModalHeader
        toggle={toggleForm}
        close={
          <button className="close" onClick={toggleForm}>
            {/* <Icon name="cross" /> */}
          </button>
        }
      >
        State Filter
      </ModalHeader>
      <ModalBody className="modal-body">
        <div className="d-flex justify-content-center align-items-center">
          {isMobile ? (
            <MobileSelector
              options={options}
              selected={userData.data}
              preSelected={userData.data}
              handleSelectedState={localHandleSelectedState}
            />
          ) : (
            <ReactDualList
              setSelectedelectedZonesLastModified={
                setSelectedelectedZonesLastModified
              }
              selectedZonesLastModified={selectedZonesLastModified}
              options={options}
              canFilter={true}
              className="dual-listbox-container"
              handleSelectedState={localHandleSelectedState}
              userData={userData}
              preSelected={userData.data}
              selectedZone={selectedZone}
              setSelectedZone={setSelectedZone}
            />
          )}
        </div>
        <Row className="justify-content-end mx-auto pt-4">
          <Col className="col-auto px-0">
            <Button
              color="white"
              size="lg"
              onClick={toggleForm}
              disabled={loading}
            >
              Cancel
            </Button>
          </Col>
          <Col className="col-auto px-0">
            <Button
              color="primary"
              type="submit"
              size="lg"
              disabled={loading}
              onClick={() => {
                userData.setMutationCall();
                toggleForm();
                handleSelectedState(selectedStates);
              }}
            >
              {loading ? <Spinner color="white" size="sm" /> : "Update"}
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default UsStateSelectModal;
